<template>
  <div data-testid="explore-skeletons">
    <v-skeleton-loader type="text" width="80" class="mb-4 ml-4" />
    <v-row class="ma-0">
      <v-col
        :lg="cols"
        sm="6"
        md="4"
        class="mb-3"
        v-for="item in 15"
        :key="item"
      >
        <v-card outlined height="250" class="pa-4">
          <v-skeleton-loader type="image" height="120"></v-skeleton-loader>
          <v-skeleton-loader type="sentences" class="mt-2"></v-skeleton-loader>
          <v-skeleton-loader
            type="text"
            width="80"
            class="mt-10"
          ></v-skeleton-loader>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'ExploreSkeletons',

  props: {
    cols: Number,
  },
}
</script>
